import React from 'react';
import styles from './InboundCallManagement.module.css';

const InboundCallManagement = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>How inbound calls are managed</h2>
      <p className={styles.description}>
        ToxBox uses an AI-powered voice assistant to handle inbound calls automatically, ensuring your customers receive prompt and intelligent support without the need for human intervention (unless required).
      </p>

      <h4 className={styles.subheading}>Here’s how it works:</h4>

      <div className={styles.step}>
        <strong>1. Call Received</strong>
        <p>
          When a customer calls your business number, the virtual receptionist answers instantly with a friendly, customized greeting.
        </p>
      </div>

      <div className={styles.step}>
        <strong>2. Natural Language Understanding</strong>
        <p>
          The AI listens and understands the caller’s request using Natural Language Processing (NLP).
        </p>
      </div>

      <div className={styles.step}>
        <strong>3. Smart Response Handling</strong>
        <p>Based on the caller’s intent, the AI can:</p>
        <ul className={styles.list}>
          <li>Answer frequently asked questions (e.g., hours, services, location)</li>
          <li>Collect information like name, email, issue type</li>
          <li>Route the call to the appropriate department or agent</li>
          <li>Book appointments or take orders</li>
          <li>Escalate to a human agent when needed</li>
        </ul>
      </div>

      <div className={styles.step}>
        <strong>4. Call Summary and Logging</strong>
        <p>
          After the call, the system logs a summary with important details (caller info, intent, outcome) in your dashboard or connected CRM.
        </p>
      </div>

      <div className={styles.step}>
        <strong>5. 24/7 Availability</strong>
        <p>
          Inbound calls can be managed round the clock—even outside business hours—ensuring no customer is left unattended.
        </p>
      </div>
    </div>
  );
};

export default InboundCallManagement;
